import { Middleware } from "redux";
import { ApplicationState } from "../store/ApplicationState";

// {} -> https://redux.js.org/usage/usage-with-typescript
export const appConfigMiddleware: Middleware<{}, ApplicationState> = //eslint-disable-line
  () => (next) => (action: any) => {
    return next(action);
  };
